// noinspection JSValidateTypes
import React, {useState} from 'react';
import {Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import {NavLink} from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import classes from "./DrawerComp.module.css";
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import EventIcon from '@mui/icons-material/Event';
import EditCalendar from '@mui/icons-material/EditCalendar';

const DrawerComp = () => {
    const [openDrawer, setOpenDrawer] = useState(false);
    const navItems = [
        {
            id: 1,
            to: "/",
            title: "صفحه اصلی",
            icon: <HomeIcon/>
        },
        {
            id: 2,
            to: "/programs/daily",
            title: "برنامه ها",
            icon: <EditCalendar/>
        },
        {
            id: 3,
            to: "/events",
            title: "ایونت ها",
            icon: <EventIcon/>
        },
        {
            id: 4,
            to: "/#about_us",
            title: "درباره ما",
            icon: <InfoIcon/>
        },
        {
            id: 5,
            to: "/contact-us",
            title: "تماس با ما",
            icon: <PermContactCalendarIcon/>
        }
    ]

    return (
        <>
            <Drawer open={openDrawer} onClose={() => setOpenDrawer(false)}>
                <List>
                    {
                        navItems?.map(page => (
                            <ListItem key={page.id} sx={{width: '240px'}}>
                                <ListItemButton className={classes.navLink} onClick={() => setOpenDrawer(false)}
                                                edge="start"
                                                sx={{flexDirection: 'row-reverse', justifyContent: 'space-between'}}
                                >
                                    <ListItemIcon sx={{
                                        minWidth: 36,
                                        justifyContent: 'flex-end',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        {page?.icon}
                                    </ListItemIcon>
                                    <ListItemText
                                        sx={{justifyContent: 'flex-end', display: 'flex', alignItems: 'center'}}>
                                        <NavLink className={({isActive}) =>
                                            isActive && page.to !== '/#about_us' ? `${classes.active} ${classes.navLink}` : classes.navLink
                                        } style={{textDecoration: "none", fontSize: "1.4rem"}}
                                                 to={page.to}>{page.title}
                                        </NavLink>
                                    </ListItemText>
                                </ListItemButton>
                            </ListItem>
                        ))

                    }

                </List>
            </Drawer>
            <IconButton sx={{color: "#fff"}} onClick={() => setOpenDrawer(!openDrawer)}>
                <MenuIcon/>
            </IconButton>
        </>
    );
};

export default DrawerComp;

